import Vue from 'vue'
import App from './app.vue'

// 计算自适应手机屏幕宽
var remSize = window.screen.width / 37.5 + 'px'
document.documentElement.style.fontSize = remSize

new Vue({
  el: '#app',
  render: h => h(App)
})
